import React from 'react';

/**
 * ImpactUpperText
 * 
 * Displays the main text and button for the upper part of the Impact section.
 * This component overlays the ImpactVisual background image.
 */
export const ImpactUpperText = ({ t, openDialog, DEV_MODE, showImpact, hideCalculator }) => {
  return (
    <div className="mr-impact-upper">
      <div>
        <h3 dangerouslySetInnerHTML={{ __html: t("impact.upper_header") }} />
        {!hideCalculator && (
          <button onClick={() => openDialog('carbon-calculator')}>
            {t("impact.calculate_button")}
          </button>
        )}
      </div>
    </div>
  );
};
